import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

export default function ApplicationClosed() {
    return (
        <Box
            sx={{
                width: '100%',
                position: 'relative',
                textAlign: 'center',
                color: 'white',
                pt: 4,
                pb: 2,
                backgroundColor: '#1f1f1f'
            }}
        >
            <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 1 }}>
                {/* Status Label */}
                <Typography
                    variant="subtitle1"
                    sx={{
                        color: '#1e88e5',
                        fontWeight: 'bold',
                        mb: 2,
                    }}
                >
                    Applications are Closed
                </Typography>

                {/* Headline */}
                <Typography
                    variant="h2"
                    sx={{
                        fontSize: '32px',
                        fontWeight: '600',
                        mb: 4,
                    }}
                >
                    Stay Tuned for Updates
                </Typography>

                {/* Body Text */}
                <Typography
                    variant="body1"
                    sx={{
                        color: 'rgba(255, 255, 255, 0.85)',
                        mb: 4,
                    }}
                >
                    Thank you for your interest in the <strong>AWS Cloud Bootcamp</strong>!
                    Applications for the current cohort are now closed. Stay connected with us through our social media channels for announcements on upcoming bootcamps.
                </Typography>
            </Container>
        </Box>
    );
}
